import * as React from 'react';
import { isDayPickerSingle } from '../../types';
import { SelectSingleContext } from './SelectSingleContext';
/** Provides the values for the [[SelectSingleProvider]]. */
export function SelectSingleProvider(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var initialSelected;
    if (isDayPickerSingle(initialProps)) {
        initialSelected = initialProps.defaultSelected;
    }
    var _b = React.useState(initialSelected), selected = _b[0], setSelected = _b[1];
    var handleDayClick = function (day, dayModifiers, e) {
        var _a, _b;
        if (!isDayPickerSingle(initialProps))
            return;
        if (dayModifiers.selected && !initialProps.required) {
            setSelected(undefined);
            (_a = initialProps.onSelect) === null || _a === void 0 ? void 0 : _a.call(initialProps, undefined, day, dayModifiers, e);
            return;
        }
        setSelected(day);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, day, day, dayModifiers, e);
    };
    var modifiers = { selected: [] };
    if (selected)
        modifiers.selected = [selected];
    return (React.createElement(SelectSingleContext.Provider, { value: { selected: selected, handleDayClick: handleDayClick, modifiers: modifiers } }, children));
}
//# sourceMappingURL=SelectSingleProvider.js.map